import { useCallback, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';

type ToggleWithValue = (toggleValue?: unknown) => void;
type ToggleWithouValue = () => void;
export type ToggleAction = ToggleWithValue | ToggleWithouValue;

export function useToggle(defaultValue?: boolean): [boolean, ToggleAction, Dispatch<SetStateAction<boolean>>] {
    const [value, setValue] = useState(!!defaultValue);

    // We can pass this to onClick={toggleFn} and still get default behavior, but we can use toggle(true) to force-set in some cases.
    const toggle = useCallback((toggleValue?: unknown) => {
        setValue((x) => (typeof toggleValue === 'boolean' ? toggleValue : !x));
    }, []);

    return [value, toggle, setValue];
}
